import { message } from "antd";
import { useMutation } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setLoader } from "../Slices/loaderSlice";
import {  EDIT_WORKHISTORY } from "../Queries/Employees";
import { setEditHistory } from "../Slices/employeeslice";
import { updateEmployee } from "../Slices/Thunk/employeeThunk";
import { useErrorLogger } from "../utils";
import { setBtn } from "../Slices/employeeslice";
import { useEffect } from "react";
export const useFormHandler = () => {
  const dispatch = useDispatch();
  const { Empid } = useParams();
  const details = useSelector((state) => state.employee.AllEmployees);
  const disable=useSelector((state)=>state.employee.button)
  const { logError } = useErrorLogger();
  
   const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  
  useEffect(()=>{
    setTimeout(()=>{
      dispatch(setBtn(false))
    },3000)
  },[disable])
  const id = loginUser?.id;
  const ids = Empid ? Empid : id
  const employee = details.find((emp) => emp.id === id);
  const [EditemployeeDetails] = useMutation(EDIT_WORKHISTORY);

  const handleSubmit = async ({ noErrors, formValid, dataObj, action, ModalName, submitAction }) => {
    dispatch(setBtn(true))
    if (noErrors && !formValid) {
      message.error({
        content: "No Change Detected to Update",
        duration: 2,
      });
      return false;
    }
    try {
      if (noErrors && formValid) {
        dispatch(setLoader(true));
        const response = await dispatch(updateEmployee({ id: ids, input: dataObj }));
        if (response?.payload) {
          await EditemployeeDetails({
            variables: {
              input: {
                id:id,
                empid: Empid,
                action,
                userName: `${employee?.firstname}  ${employee?.lastname}`,
                EditStatus: "Updated",
                changeTime: new Date().toISOString(),
              }
            }
          })
          dispatch(
            setEditHistory({
              id,
              empid: Empid,
              action,
              userName: `${employee?.firstname}  ${employee?.lastname}`,
              EditStatus: "Updated",
              changeTime: new Date().toISOString(),
            })
          );
          dispatch(setLoader(false));
          message.success({
            content: "Updated Successfully",
            duration: 2,
          });
          return true;
        }
        }
      } catch (error) {
        logError(ModalName, submitAction)
        dispatch(setLoader(false));
        throw error;
      } finally {
        dispatch(setLoader(false));
      }

      return false;
    };


    return { handleSubmit };
  };
